import { Box } from "@dropbox/dig-foundations";
import { useEffect, useRef } from "react";
import { useStackTrialUpsell } from "./useStackTrialUpsell";

type StackTrialUpsellContainerProps = {
  maxWidth?: string;
};

export const StackTrialUpsellContainer = ({
  maxWidth = "760px",
}: StackTrialUpsellContainerProps) => {
  const {
    hideTrialNotification,
    isTrialNotificationVisible,
    setStackContainerRef,
  } = useStackTrialUpsell();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    hideTrialNotification();
    setStackContainerRef(containerRef);

    return () => {
      // reset container and hide notification so it doesn't appear in wrong place in the DOM
      setStackContainerRef(null);
      hideTrialNotification();
    };
  }, [setStackContainerRef]);

  const paddingAmount = isTrialNotificationVisible ? "12" : "0";

  return (
    <Box
      width="100%"
      position="fixed"
      bottom="0"
      style={{ pointerEvents: "none" }}
    >
      <Box
        ref={containerRef}
        style={{
          maxWidth,
          position: "relative",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        width="100%"
        paddingLeft={paddingAmount}
        paddingRight={paddingAmount}
        paddingBottom={paddingAmount}
        backgroundColor="transparent"
        data-testid="stack-trial-upsell-container"
      />
    </Box>
  );
};
